import { mediaIdFromLibraryUrl } from './mediaLibraryUrls';

/**
 * Replace maintella-media:// img src values with presigned download URLs for display.
 * Does not mutate stored workflow HTML — use only for editor/runtime preview.
 *
 * When trackMediaIds is true (editor), sets data-media-library-id so save can restore refs.
 */
export async function resolveMaintellaMediaInHtml(html, fetchDownloadUrl, { trackMediaIds = false } = {}) {
  if (!html || typeof document === 'undefined') return html || '';

  const template = document.createElement('template');
  template.innerHTML = html;
  const images = template.content.querySelectorAll('img');

  await Promise.all(
    Array.from(images).map(async (img) => {
      const mediaId = mediaIdFromLibraryUrl(img.getAttribute('src'));
      if (!mediaId) return;

      if (trackMediaIds) {
        img.dataset.mediaLibraryId = String(mediaId);
      }

      try {
        const url = await fetchDownloadUrl(mediaId);
        if (url) img.setAttribute('src', url);
      } catch {
        // keep maintella-media src if fetch fails
      }
    })
  );

  return template.innerHTML;
}
